import React from 'react';
import {useTranslate} from "../../../system/useTranslate";
import Avatar from "../../../system/components/avatar";
import Icon from "../../../system/components/icon";
import { useRef, useState } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { ListBox } from "primereact/listbox";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

function SelectMember({selectedMember, members=[], onChange, label="", ariaLabel, hideLabel, primeDropdown=false, fullWidth=false}) {
    const translate = useTranslate();
    const overlayRef = useRef(null);
    const [panelWidth, setPanelWidth] = useState(null);
    const memberProfile = (membership) => membership?.member || membership;
    const membershipKey = (membership) => membership?.documentId || membership?.id;
    let options = [{label:label, value:-1}];
    options = options.concat(members?.map((membership) => ({
        label: memberProfile(membership)?.fullname,
        value: membershipKey(membership),
        className:"p-0",
        data: membership,
    })));
    function ItemTemplate(option) {
        const member = memberProfile(option?.data);
        return(
                <div className="flex align-items-center gap-2 p-2">                    {member && (
                    <Avatar
                            className="text-3xs"
                            style={{ width: "1.48rem", height: "1.48rem" }}
                            memberData={member}
                        />
                    )}
                    <div className="flex flex-column">
                        {option?.label?<span className="text-xs">{option?.label}</span>:<Icon icon="mi mi:person" className="text-lg"/>}
                        {/*<span className="text-xs text-300">{}</span>*/}
                    </div>
                    {/*{option.value>0&&<i className="pi pi-chevron-left text-xs"/>}*/}
                </div>



        )
    }

    return (
        <div className={`flex align-items-center gap-1 flex-wrap ${fullWidth ? "w-full" : ""}`}>
            <Button type="button" text severity="secondary" aria-label={ariaLabel || memberProfile(selectedMember)?.fullname || label || translate("select-member")} className={`border-none bg-transparent p-0 flex align-items-center cursor-pointer shadow-none outline-none ${fullWidth ? "w-full justify-content-between" : ""}`} style={{outline: "none", boxShadow: "none"}} onClick={(e) => {
                if (fullWidth) setPanelWidth(e.currentTarget.getBoundingClientRect().width);
                overlayRef.current.toggle(e);
            }}>
                <ItemTemplate
                    label={memberProfile(selectedMember)?.fullname || label}
                    data={selectedMember}
                />

                <Icon
                    icon="mi mi:keyboard_arrow_down"
                    className="text-lg"
                />
            </Button>

            <OverlayPanel ref={overlayRef} pt={{
                root: () => ({
                    className: "p-0 rtl w-15rem project-overlay"
                }),
                content: () => ({
                    className: "p-0"
                })
            }} style={fullWidth && panelWidth ? {width: `${panelWidth}px`} : undefined}>
                <ListBox
                    className="w-15rem border-none"
                    filter
                    filterBy="label"
                    options={options}
                    value={membershipKey(selectedMember) || -1}
                    itemTemplate={ItemTemplate}
                    filterTemplate={(options) => (
                        <div className="p-0  border-200">
                            <InputText
                                placeholder={translate("search-member-placeholder")}
                                className="w-full text-xs"
                                onChange={options.filterOptions.filter}
                            />
                        </div>
                    )}

                    onChange={(e) => {
                        onChange(
                            members.find((membership) => membershipKey(membership) === e.value) ?? null
                        );

                        overlayRef.current.hide();
                    }}
                />
            </OverlayPanel>
        </div>
    );
}

export default SelectMember;
